import { FC } from "react";
import { Box } from "@material-ui/core";
import { DsmIcon } from "@dsm-dcs/design-system-react";
import clsx from "clsx";
import { useIntl } from "../../../../../_metronic/i18n/customUseIntl";
import { roiResultsStyles } from "../../../../ThemeProvider";
import { formatRoiPercentage } from "../../../helpers/roiFormatters";
import {
  DSM_LIME_GREEN,
  DSM_RED,
} from "../../../../../_metronic/layout/_core/MaterialThemeProvider";

interface PercentageBadgeProps {
  value: number;
}

const PercentageBadge: FC<PercentageBadgeProps> = ({ value }) => {
  const { locale } = useIntl();
  const classes = roiResultsStyles();
  const isDecrease = value >= 0;

  return (
    <Box
      className={clsx(
        classes.percentageBadge,
        isDecrease
          ? classes.percentageBadgeDecrease
          : classes.percentageBadgeIncrease,
      )}
    >
      <DsmIcon
        name={isDecrease ? "arrows/arrow-down" : "arrows/arrow-up"}
        className={classes.percentageIcon}
        style={{ color: isDecrease ? DSM_LIME_GREEN : DSM_RED }}
      />
      {formatRoiPercentage(value, locale)}
    </Box>
  );
};

export default PercentageBadge;
